import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import PropTypes from "prop-types";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import ReportHeader from "../report-header";

import {
    requestExportMiscChargeReportExcel
} from "../../../../actions/draftActions";
import MiscChargeReportList from "./misc-charge-report-list";


class MiscChargeReportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {
                fromDate: moment()
                    .startOf("month"),
                toDate: moment()
                    .endOf("month"),
                merchandiserId: { value: null, label: "All Merchandisers" },
            },
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect = (name, option) => {
        const filters = Object.assign({}, this.state.filters);
        filters[name] = option;
        this.setState({
            filters
        });
    };

    render() {
        const {
            filters
        } = this.state;

        return (
            <div className="position-relative container">
                <ReportHeader
                    filters={filters}
                    handleSelect={this.handleSelect}
                    isChargeApproval={true}
                />
                <MiscChargeReportList
                    filters={filters}
                    handleClose={this.props.handleClose}
                    handleSubmit={this.props.requestExportMiscChargeReportExcel}
                />
            </div>
        );
    }
}

MiscChargeReportModal.propTypes = {
    handleClose: PropTypes.func.isRequired
};

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
    requestExportMiscChargeReportExcel: bindActionCreators(
        requestExportMiscChargeReportExcel, dispatch
)
});

export default connect(
    null,
    mapStateToDispatch
)(MiscChargeReportModal);
